<template>
  <div class='animated fadeIn'>
    <b-row class='justify-content-md-center'>
      <b-col cols='12' lg='10'>
        <b-card class='shadow-sm bg-white rounded' border-variant='light'>
          <div>
            <el-button type='success' icon='el-icon-back' circle @click='goBack'></el-button>
          </div>
        </b-card>
        <b-card class='shadow-sm bg-white rounded' border-variant='light' header-bg-variant='secondary'>
          <b-list-group flush>
            <b-list-group-item>
                <b-row class='justify-content-md-center'>
                  <b-col sm='2'>
                    <b-img v-if='group.icon' :src='group.icon' width='128' height='128' rounded></b-img>
                    <b-img v-else-if='group.key != null' border-variant='white' width='128' height='128' rounded></b-img>
                  </b-col>
                  <b-col sm='7'>
                    <croppa
                      v-model='myCroppa'
                      :width='256'
                      :height='256'
                      :auto-sizing='true'
                      placeholder='アイコン画像選択'
                      :placeholder-font-size='14'
                      :accept="'image/*'"></croppa>
                  </b-col>
                  <b-col sm='2'>
                    <b-button v-if='group.key' class='submit-btn' variant='danger' v-b-modal.modal-center>更新</b-button>
                    <b-button v-else class='submit-btn' variant='danger' v-b-modal.modal-center>登録</b-button>
                    <b-modal v-if='group.key' id='modal-center'
                            ref='modal'
                            title='グループ'
                            @ok='storeData'
                            centered
                            header-bg-variant='danger'
                            body-text-variant='danger'
                            ok-variant='danger'
                            size='sm'
                            class='px100-btn'
                          >
                      <p class='my-4'>グループを更新します</p>
                      <p class='my-4'>よろしいですか?</p>
                    </b-modal>
                    <b-modal v-else id='modal-center'
                            ref='modal'
                            title='グループ'
                            @ok='storeData'
                            centered
                            header-bg-variant='danger'
                            body-text-variant='danger'
                            ok-variant='danger'
                            size='sm'
                            class='px100-btn'
                          >
                      <p class='my-4'>グループを登録します</p>
                      <p class='my-4'>よろしいですか?</p>
                    </b-modal>
                  </b-col>
                </b-row>
            </b-list-group-item>
            <b-list-group-item>
              <b-card-body>
                <b-row>
                  <b-col sm='3'><label for='input-none'>{{getTitle('name')}}:</label></b-col>
                  <b-col sm='9'><el-input size='medium' type='text' v-model='group.name'></el-input></b-col>
                </b-row>
                <b-row>
                  <b-col sm='3'><label for='input-none'>{{getTitle('subTitle')}}:</label></b-col>
                  <b-col sm='9'><el-input size='medium' type='text' v-model='group.subTitle'></el-input></b-col>
                </b-row>
              </b-card-body>
            </b-list-group-item>

            <b-list-group-item v-if="user && user.role == 'admin'">
              <b-card-body>
                <b-row>
                  <b-col sm='4'><label for='input-none'>{{getTitle('services')}}:</label></b-col>
                  <b-col sm='2'></b-col>
                </b-row>
                <b-row>
                  <b-col sm='2'></b-col>
                  <b-col sm='10'>
                   <b-table
                      :items='services'
                      :fields='fields'
                      >
                      <div slot='icon' class='avatar' slot-scope='item'>
                        <b-img v-if='item.value' :src='item.value' width='32' height='32'></b-img>
                        <!-- <b-img v-else src='../admin.png' width='32' height='32' class='img-avatar'></b-img> -->
                      </div>
                      <div slot='name' slot-scope='item'>
                        <p>{{ item.value }}</p>
                      </div>
                      <div slot='key' slot-scope='item'>
                        <b-form-checkbox :id='item.value' v-model='selectedService[item.value]' @change="changeService()"></b-form-checkbox>
                      </div>
                    </b-table>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-list-group-item>

            <b-list-group-item>
              <b-card-body>
                <b-row>
                <b-col sm='4'><label for='input-none'>{{getTitle('users')}}:</label></b-col>
                <b-col sm='2'></b-col>
                </b-row>
                <b-row>
                  <b-col sm='2'></b-col>
                  <b-col sm='10'>
                    <b-table
                      :items='myUsers'
                      :fields='fieldsUsers'
                      :current-page='currentPage'
                      :per-page='perPage'>
                      <div slot='icon' class='avatar' slot-scope='item'>
                        <b-img v-if='item.value' :src='item.value' width='32' height='32'></b-img>
                        <!-- <b-img v-else src='../admin.png' width='32' height='32' class='img-avatar'></b-img> -->
                      </div>
                      <div slot='name' slot-scope='item'>
                        <p>{{ item.value }}</p>
                      </div>
                      <div slot='key' slot-scope='item'>
                        <b-form-checkbox :id='item.value' v-model='selected[item.value]' @change="changeUser()"></b-form-checkbox>
                      </div>
                    </b-table>
                    <b-pagination align='center' size='sm' :total-rows='myUsers.length' v-model='currentPage' :per-page='perPage'>
                    </b-pagination>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-list-group-item>

            <b-list-group-item>
              <b-card-body>
                <b-row>
                  <b-col sm='4'><label for='input-none'>{{getTitle('enable')}}:</label></b-col>
                  <b-col>
                    <b-form-checkbox id='checkbox3' v-model='group.enable'></b-form-checkbox>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm='4'><label for='input-none'>{{getTitle('updatedAt')}}:</label></b-col>
                  <b-col>{{ group.updatedAt * 1000 | moment }}</b-col>
                </b-row>
                <b-row>
                  <b-col sm='4'><label for='input-none'>{{getTitle('createdAt')}}:</label></b-col>
                  <b-col>{{ group.createdAt * 1000 | moment }}</b-col>
                </b-row>
                <b-row>
                  <b-col sm='4'><label for='input-none'>{{getTitle('owner')}}:</label></b-col>
                  <b-col>
                    <b-img v-if='getUserIcon(group)' :src='getUserIcon(group)' width='32' height='32' class='img-avatar'></b-img>
                    <!-- <b-img v-else src='../admin.png' width='32' height='32' class='img-avatar'></b-img> -->
                  </b-col>
                </b-row>
              </b-card-body>
            </b-list-group-item>
            <b-list-group-item v-if='group.key != null'>
              <b-card-body>
                <b-row>
                  <b-col sm='3'><label for='input-none'>ルーティンリファレンス:</label></b-col>
                  <b-col sm='9'>
                    <el-transfer
                      :titles="['未選択', '選択中']"
                      target-order='unshift'
                      filterable
                      :filter-method='filterMethod'
                      filter-placeholder='Keyword'
                      v-model='routineSelected'
                      :data='routineList'>
                    </el-transfer>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-list-group-item>
          </b-list-group>
        </b-card>
        <b-modal ref='errorModal' centered title='Error' class='text-danger' :ok-only='true' ok-variant=danger header-bg-variant=danger>
          <p class='my-4'>{{errorMessage}}</p>
        </b-modal>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/storage'
import moment from 'moment'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      routineList: [],
      routineSelected: [],
      fields: {
        icon: {
          label: '',
          class: 'text-center'
        },
        name: {
          label: '名称',
          class: 'text-center',
          sortable: true
        },
        key: {
          label: '',
          class: 'text-center'
        }
      },
      fieldsUsers: {
        icon: {
          label: '',
          class: 'text-center'
        },
        name: {
          label: '名称',
          class: 'text-center',
          sortable: true
        },
        email: {
          label: 'Email',
          class: 'text-center',
          sortable: true
        },
        key: {
          label: '',
          class: 'text-center'
        }
      },
      currentPage: 1,
      perPage: 10,
      myCroppa: {},
      errorMessage: '',
      file: null,
      uploadedImage: null,
      titles: {
        'owner': '作成',
        'name': '名称',
        'services': '所属サービス',
        'users': '登録ユーザ',
        'subTitle': '説明',
        'icon': 'Icon',
        'routine': 'Routine',
        'chats_ref': 'Chats room reference',
        'enable': '有効',
        'updatedAt': '更新日時',
        'createdAt': '作成日時'
      },
      group: null,
      groupSave: null,
      selected: {},
      unwatch0: null,
      unwatch1: null,
      service: null,
      unsubscribe: null,
      myUsers: [],
      selectedService: {},
      isChangeService: false,
      isChangeUser: false
    }
  },
  beforeDestroy () {
    if (this.unwatch) {
      this.unwatch()
    }
    if (this.unsubscribe) {
      this.unsubscribe()
    }
  },
  created () {
    this.unwatch0 = this.$store.watch(state => this.$store.getters['group/groups'], value => {
      this.init()
    })
    this.unwatch1 = this.$store.watch(state => this.$store.getters['service/services'], value => {
      this.init()
    })
    this.init()
  },
  methods: {
    changeService () {
      this.isChangeService = true
    },
    changeUser () {
      this.isChangeUser = true
    },
    usersLen () {
      return Object.keys(this.group.users).length
    },
    init () {
      this.selected = {}
      const index = this.groups.findIndex(group => group.key === this.parameter)
      if (index !== -1) {
        this.group = JSON.parse(JSON.stringify(this.groups[index]))
      } else {
        this.group = {
          'key': null,
          'owner': this.user.key,
          'services': JSON.parse(JSON.stringify(this.user.services)),
          'users': {},
          'name': '',
          'subTitle': '',
          'icon': '',
          'routine': [],
          'chats_ref': '',
          'enable': true,
          'createdAt': parseInt(new Date().getTime() / 1000),
          'updatedAt': parseInt(new Date().getTime() / 1000)
        }
        this.isChangeService = true
      }
      var keys = Object.keys(this.group.services)
      for (var i in keys) {
        if (this.group.services[keys[i]]) {
          this.selectedService[keys[i]] = this.group.services[keys[i]]
        }
      }
      this.getMyUsers()
      this.groupSave = JSON.parse(JSON.stringify(this.group))
      this.getRoutineBelongs()
    },
    showModal () {
      this.$refs.errorModal.show()
    },
    hideModal () {
      this.$refs.errorModal.hide()
    },
    generateImage: function () {
      let url = this.myCroppa.generateDataUrl()
      if (!url) {
        this.errorMessage = 'No image selected'
        this.showModal()
      }
    },
    goBack () {
      this.$router.go(-1)
    },
    getTitle (item) {
      return this.titles[item]
    },
    onFileSelected (event) {
      this.file = event.target.files[0]
      this.createImage(this.file)
    },
    getUserIcon (group) {
      const index = this.users.findIndex(user => user.key === group.owner)
      if (index !== -1) {
        return this.users[index].icon
      }
      return null
    },
    getMyUsers () {
      this.myUsers = []
      this.selected = {}
      for (var key in this.group.services) {
        if (this.group.services[key]) {
          for (var index in this.users) {
            var user = this.users[index]
            if (user.services[key]) {
              this.myUsers.push(user)
              if (this.group.users[user.key]) {
                this.selected[user.key] = true
              } else {
                this.selected[user.key] = false
              }
            }
          }
        }
      }
    },
    createImage (file) {
      let reader = new FileReader()
      reader.onload = (e) => {
        this.group.icon = e.target.result
      }
      reader.readAsDataURL(file)
    },
    generateUuid () {
      let chars = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.split('')
      for (let i = 0, len = chars.length; i < len; i++) {
        switch (chars[i]) {
          case 'x':
            chars[i] = Math.floor(Math.random() * 16).toString(16)
            break
          case 'y':
            chars[i] = (Math.floor(Math.random() * 4) + 8).toString(16)
            break
        }
      }
      return chars.join('')
    },
    writegroup () {
      var vm = this
      var before = JSON.parse(JSON.stringify(this.groupSave))
      var temp = {}
      var tempS = {}
      var keys = Object.keys(this.selected)
      for (var x in keys) {
        if (this.selected[keys[x]]) {
          temp[keys[x]] = true
        }
      }
      keys = Object.keys(this.selectedService)
      for (x in keys) {
        if (this.selectedService[keys[x]]) {
          tempS[keys[x]] = true
        }
      }
      const payload = {
        'owner': this.group.owner,
        'services': tempS,
        'users': temp,
        'name': this.group.name,
        'subTitle': this.group.subTitle,
        'icon': this.group.icon,
        'routine': this.group.routine,
        'chats_ref': this.group.chats_ref,
        'enable': this.group.enable,
        'createdAt': this.group.createdAt,
        'updatedAt': parseInt(new Date().getTime() / 1000)
      }
      var routineRef = []
      for (var i = 0; i < this.routineSelected.length; i++) {
        var routine = this.routineList[this.routineSelected[i]]
        routineRef.push(routine.initial)
      }
      payload.routine = routineRef

      const db = firebase.firestore()
      const settings = { timestampsInSnapshots: true }
      db.settings(settings)
      const batch = db.batch()
      var refgroup = null
      if (this.group.key) {
        refgroup = db.collection('groups').doc(this.group.key)
      } else {
        refgroup = db.collection('groups').doc()
      }

      if (!this.group.key) {
        var refChats = db.collection('chats').doc()
        batch.set(refChats, { 'unread': {}, 'read': {}, 'last': null, 'createdAt': parseInt(new Date().getTime() / 1000) })

        var refChatsRefs = db.collection('chats_refs').doc(refgroup.id)
        batch.set(refChatsRefs, {'chats_ref': refChats.id, 'createdAt': parseInt(new Date().getTime() / 1000)})

        payload.chats_ref = refChats.id
        batch.set(refgroup, payload)

        var refChatsRefFrom = db.collection('chats_refs').doc(refgroup.id).collection('refs').doc(payload.owner)
        batch.set(refChatsRefFrom,
          {
            'location': refChats.id,
            'type': 'group',
            'status': 'pending',
            'enable': false,
            'createdAt': parseInt(new Date().getTime() / 1000),
            'updatedAt': parseInt(new Date().getTime() / 1000)
          }
        )
        var refChatsRefTo = db.collection('chats_refs').doc(payload.owner).collection('refs').doc(refgroup.id)
        batch.set(refChatsRefTo,
          {
            'location': refChats.id,
            'type': 'group',
            'status': 'requesting',
            'enable': false,
            'createdAt': parseInt(new Date().getTime() / 1000),
            'updatedAt': parseInt(new Date().getTime() / 1000)
          }
        )
      } else {
        batch.set(refgroup, payload)
      }

      if (this.isChangeUser) {
        for (var key in payload.users) {
          if (payload.users[key] && !before.users[key]) {
            refChatsRefFrom = db.collection('chats_refs').doc(refgroup.id).collection('refs').doc(key)
            batch.set(refChatsRefFrom,
              {
                'location': payload.chats_ref,
                'type': 'group',
                'status': 'pending',
                'enable': false,
                'createdAt': parseInt(new Date().getTime() / 1000),
                'updatedAt': parseInt(new Date().getTime() / 1000)
              }
            )
            refChatsRefTo = db.collection('chats_refs').doc(key).collection('refs').doc(refgroup.id)
            batch.set(refChatsRefTo,
              {
                'location': payload.chats_ref,
                'type': 'group',
                'status': 'requesting',
                'enable': false,
                'createdAt': parseInt(new Date().getTime() / 1000),
                'updatedAt': parseInt(new Date().getTime() / 1000)
              }
            )
          }
        }
        for (key in before.users) {
          if (!payload.users[key] && before.users[key]) {
            refChatsRefFrom = db.collection('chats_refs').doc(refgroup.id).collection('refs').doc(key)
            batch.delete(refChatsRefFrom)

            refChatsRefTo = db.collection('chats_refs').doc(key).collection('refs').doc(refgroup.id)
            batch.delete(refChatsRefTo)
          }
        }
      }

      batch.commit().then(function () {
        var async = require('async')
        if (vm.isChangeService) {
          vm.isChangeService = false
          var services = JSON.parse(JSON.stringify(vm.services))
          async.each(services, function (service, cb) {
            if (vm.checkIfModifiedService(payload, service, before) || before.key === null) {
              var refService = db.collection('services').doc(service.key)
              db.runTransaction(function (transaction) {
                return transaction.get(refService).then(function (doc) {
                  if (!doc.exists) {
                    throw new Error('Document does not exist!')
                  }
                  var groups = doc.data().groups
                  if (payload.services[service.key]) {
                    groups[refgroup.id] = payload.services[service.key]
                  } else {
                    delete groups[refgroup.id]
                  }
                  transaction.update(refService, { groups: groups })
                  transaction.update(refService, { updatedAt: parseInt(new Date().getTime() / 1000) })
                })
              }).then(function () {
                cb()
                // console.log('Transaction successfully committed!')
              }).catch(function (error) {
                cb()
                console.log('Transaction failed: ', error)
              })
            } else {
              cb()
            }
          }, function (err) {
            if (err) console.log(err)
          })
        }
        if (vm.isChangeUser) {
          vm.isChangeUser = false
          var users = JSON.parse(JSON.stringify(vm.users))
          async.each(users, function (user, cb) {
            if (vm.checkIfModified(payload, user, before)) {
              var refUser = db.collection('users').doc(user.key)
              db.runTransaction(function (transaction) {
                return transaction.get(refUser).then(function (doc) {
                  if (!doc.exists) {
                    throw new Error('Document does not exist!')
                  }
                  var groups = doc.data().groups
                  if (payload.users[user.key]) {
                    groups[refgroup.id] = payload.users[user.key]
                  } else {
                    delete groups[refgroup.id]
                  }
                  transaction.update(refUser, { groups: groups })
                  transaction.update(refUser, { updatedAt: parseInt(new Date().getTime() / 1000) })
                })
              }).then(function () {
                cb()
                // console.log('Transaction successfully committed!')
              }).catch(function (error) {
                cb()
                console.log('Transaction failed: ', error)
              })
            } else {
              cb()
            }
          }, function (err) {
            vm.offLoading()
            if (err) console.log(err)
          })
        } else {
          vm.offLoading()
        }
      })
    },
    checkIfModifiedService (payload, service, before) {
      if (payload.services[service.key] !== undefined && !before.services[service.key]) {
        return true
      }
      if (before.services[service.key] !== undefined && !payload.services[service.key]) {
        return true
      }
      return false
    },
    checkIfModified (payload, user, before) {
      if (payload.users[user.key] !== undefined && !before.users[user.key]) {
        return true
      }
      if (before.users[user.key] !== undefined && !payload.users[user.key]) {
        return true
      }
      return false
    },
    storeData () {
      var vm = this
      vm.onSending()
      this.myCroppa.generateBlob((blob) => {
        if (blob) {
          var uuid = this.generateUuid()
          var storageRef = firebase.storage().ref().child('groups').child(this.group.owner).child(uuid)
          var uploadTask = storageRef.put(blob)
          uploadTask.on('state_changed', function (snapshot) {
            // var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            switch (snapshot.state) {
              case firebase.storage.TaskState.PAUSED: // or 'paused'
                break
              case firebase.storage.TaskState.RUNNING: // or 'running'
                break
            }
          }, function (error) {
            vm.offLoading()
            vm.errorMessage = error.errorMessage
            vm.showModal()
          }, function () {
            uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
              vm.group.icon = downloadURL
              vm.myCroppa.remove()
              vm.writegroup()
            })
          })
        } else {
          vm.writegroup()
        }
      })
    },
    filterMethod (query, item) {
      return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1
    },
    getRoutineBelongs () {
      var vm = this
      vm.routineList = []
      vm.routineSelected = []
      Object.keys(vm.routineRefs).forEach(function (key, index) {
        vm.routineList.push({
          label: this[key].title,
          key: index,
          initial: this[key].key
        })
        if (vm.routinesBelong !== null) {
          for (var i = 0; i < vm.group.routine.length; i++) {
            if (vm.group.routine[i].indexOf(this[key].key) >= 0) {
              vm.routineSelected.push(index)
            }
          }
        }
      }, vm.routineRefs)
    }
  },
  computed: {
    ...mapGetters({
      routines: 'routine/routines',
      routineGroups: 'routineGroup/routineGroups',
      routineRefs: 'routineRef/routineRefs',
      services: 'service/services',
      groups: 'group/groups',
      users: 'user/users',
      user: 'authUser/user',
      parameter: 'dispatch/group'
    })
  },
  filters: {
    moment: function (date) {
      return moment(date).format('YYYY/MM/DD HH:mm')
    },
    momentShort: function (date) {
      return moment(date).format('YYYY/MM/DD')
    },
    momentMMDD: function (date) {
      return moment(date).format('MM/DD')
    }
  }
}
</script>

<style>
.textTitle {
  white-space: normal;
}
.img {
  max-width: 100%;
  height: auto;
}
.row {
  padding-bottom: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/Group.vue